import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import styles from './CallToAction.module.scss';

const CallToAction = ({ rendering, fields }: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  return (
    <div id={anchorId} className={`${styles['quick-links']} background-to-change`}>
      <ScLink field={fields.link} className="ms-2" />
      <i className={`bi bi-chevron-right ms-1 px-1 ${styles['chevron']}`} />
    </div>
  );
};

export default CallToAction;
